import dayjs from "dayjs";

const reportFileExtensions = {
  pdf: "pdf",
  excel: "xlsx",
  csv: "csv",
};

const invalidFilenameCharactersPattern = /[<>:"/\\|?*\u0000-\u001F]/g;
const trailingDotsPattern = /\.+$/;
const multipleSpacesPattern = /\s+/g;
const utf8PrefixPattern = /^utf-8''/i;
const filenameStarPattern = /filename\*\s*=\s*([^;]+)/i;
const filenamePattern = /filename\s*=\s*("?)([^";]+)\1/i;

const sanitizeFilenamePart = (value = "") =>
  value
    .replace(invalidFilenameCharactersPattern, " ")
    .replace(multipleSpacesPattern, " ")
    .trim()
    .replace(trailingDotsPattern, "");

const decodeFilenameValue = (value = "") => {
  const normalizedValue = value
    .trim()
    .replace(/^['"]|['"]$/g, "")
    .replace(utf8PrefixPattern, "");

  try {
    return decodeURIComponent(normalizedValue);
  } catch {
    return normalizedValue;
  }
};

export const getReportFileExtension = (exportType = "") => {
  return reportFileExtensions[exportType] || exportType || "file";
};

export const getFilenameFromHeaders = (headers = {}) => {
  const contentDisposition =
    headers["content-disposition"] || headers["Content-Disposition"];

  if (!contentDisposition) {
    return null;
  }

  const encodedFilenameMatch = contentDisposition.match(filenameStarPattern);

  if (encodedFilenameMatch?.[1]) {
    const decodedFilename = sanitizeFilenamePart(
      decodeFilenameValue(encodedFilenameMatch[1]),
    );

    return decodedFilename || null;
  }

  const filenameMatch = contentDisposition.match(filenamePattern);

  if (filenameMatch?.[2]) {
    const decodedFilename = sanitizeFilenamePart(
      decodeFilenameValue(filenameMatch[2]),
    );

    return decodedFilename || null;
  }

  return null;
};

export const buildReportFilename = ({
  reportLabel = "",
  exportType = "",
  date = dayjs().format("YYYY-MM-DD"),
}) => {
  const sanitizedReportLabel = sanitizeFilenamePart(reportLabel) || "report";

  return `${sanitizedReportLabel}-${date}.${getReportFileExtension(exportType)}`;
};

export const resolveReportDownloadFilename = ({
  headers = {},
  reportLabel = "",
  exportType = "",
  date,
}) => {
  return (
    getFilenameFromHeaders(headers) ||
    buildReportFilename({ reportLabel, exportType, date })
  );
};

export const downloadBlobFile = ({ data, fileName }) => {
  const blob = data instanceof Blob ? data : new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
